import { render } from "./DEVJsonFormat.vue?vue&type=template&id=a1a82608&lang=pug"
import script from "./DEVJsonFormat.vue?vue&type=script&lang=js"
export * from "./DEVJsonFormat.vue?vue&type=script&lang=js"

import "./DEVJsonFormat.vue?vue&type=style&index=0&id=a1a82608&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__